import * as ActionConfigurationManager from './config.actions'

export const addToken = ActionConfigurationManager.ADD_TOKEN
export const removeToken = ActionConfigurationManager.REMOVE_TOKEN
